import styled from 'styled-components';
import { H3, P1 } from '../../styles/FontStyles';

const WithdrawalItemDisabledStyled = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.1); // dark translucent overlay
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  border-radius: 24px;
  text-align: center;
  z-index: 10;
`;

export const WithdrawalItemDisabled = () => {
  return <WithdrawalItemDisabledStyled />;
};
